// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"DataReferenceButton-module__ButtonRoot___q68q1","isSelected":"DataReferenceButton-module__isSelected___YHdfA"};